module.exports = __webpack_public_path__ + "static/media/teaser3-radeberger-x1.fe7eb55b.jpg";